import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import InteractivePropertyMap from 'components/Common/PropertyMap/InteractivePropertyMap'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  latitude: number
  longitude: number
  venueName?: string
}

function WeddingVenueMapModal(props: Props) {
  const { latitude, longitude, venueName } = props
  const intl = useIntl()
  const { resolve } = useModalElementContext()

  const handleClose = useCallback(() => {
    resolve()
  }, [resolve])

  const marker: App.MapMarker = {
    id: 'venue',
    type: 'moments',
    latitude,
    longitude,
    name: venueName,
  }

  return (
    <ModalBase size="XL" onClose={handleClose}>
      <ModalHeader
        title={venueName ?? intl.formatMessage({ defaultMessage: 'Venue location', id: 'QNsre1A01_fZfu00avw5', description: 'Fallback title shown in the wedding venue map modal.' })}
        onCloseButtonClick={handleClose}
      />
      <ModalBody>
        <InteractivePropertyMap
          markers={[marker]}
          focusOnFirstMarker
          height="60vh"
          wrapperStyle={{ height: '60vh' }}
        />
      </ModalBody>
    </ModalBase>
  )
}

export default WeddingVenueMapModal
